import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsCamera = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      


	  <g fill="currentColor">
	<path  d="M22.7493725,6.4157686c-0.0952911-0.086628-0.2209015-0.1342731-0.3530064-0.1342731h-1.1781368
		l-2.4732208-0.021657H16.536005l-0.5435877-1.8473334l-0.0021648-0.0064964
		c-0.0671358-0.2014089-0.2642145-0.3421788-0.4786177-0.3421788h-7.15977c-0.2165689,0-0.4028192,0.1429348-0.4786181,0.3660007
		L7.8710814,4.4341621L7.372973,6.2814956H1.605741c-0.2750429,0-0.5089371,0.2338943-0.5089371,0.5089369v12.6368008
		c0,0.2750435,0.2338942,0.5089378,0.5089371,0.5089378h20.7667999c0.2815399,0,0.5002747-0.2122383,0.5305939-0.5154343V6.7666106
		C22.9053001,6.6323376,22.8489933,6.5067277,22.7493725,6.4157686z M21.9350681,18.9421177H2.1146741V7.3448486h5.6589475
		c0.2165689,0,0.4028187-0.1429348,0.4786186-0.3660007L8.254405,6.9745164L8.7546797,5.127183h6.4277668h0.0000019
		l0.5435877,1.8473334l0.0021658,0.0064964c0.0671358,0.2014089,0.2642145,0.3421788,0.4786158,0.3421788h5.7282505V18.9421177z"/>
	<path  d="M12.00105,8.819684c-1.1824665,0-2.2912998,0.4612923-3.1250906,1.3015795
		c-0.831624,0.8381224-1.2885852,1.9512863-1.2885852,3.1359186c0,1.1954613,0.459126,2.3151226,1.2885852,3.1554098
		c0.8316259,0.8424549,1.9426241,1.3037453,3.1250906,1.3037453c2.4342356,0,4.4136763-2.0010967,4.4136763-4.4591551
		c0-1.1846323-0.4569607-2.2977962-1.2885866-3.1359186C14.2923498,9.2831411,13.1835155,8.819684,12.00105,8.819684z
		 M12.00105,16.7244511h-0.0693026c-1.8646584-0.0411491-3.3719797-1.5896168-3.3719797-3.4889259h0.0000019
		c0-1.8971434,1.544136-3.4412804,3.4412804-3.4412804s3.4412813,1.554965,3.4412813,3.4651022
		S13.8981953,16.7244511,12.00105,16.7244511z"/>
</g>
    </SvgIcon>
  );
});

export default AppIconsCamera;
